export default "__VITE_ASSET__DOOKLVpk__"